import {
	EMPTY_STRUCTURE_SEARCH_SESSION,
	normalizeSearchState,
	StructureSearchSession,
} from '@/pages/User/pages/Home/components/StructureSearchPanel/searchPanelUi'

import { Actions } from './actions'
import { UPDATE_SETTINGS, UPDATE_STRUCTURE_SEARCH } from './constants'

export type State = Readonly<typeof initialState>
export type SettingsSession = State

export const getSettingsSession = (state: State) => ({
	...state,
})

const initialState = {
	userInterface: {
		scriptEditor: {
			autocompleteKeywords: true,
			autocompleteSnippets: true,
			autocompleteElements: true,
		},
	},
	structureSearch: EMPTY_STRUCTURE_SEARCH_SESSION as StructureSearchSession,
}

const normalizeStructureSearch = (
	value: Partial<StructureSearchSession> | undefined,
	fallback: StructureSearchSession = EMPTY_STRUCTURE_SEARCH_SESSION,
): StructureSearchSession => ({
	q: typeof value?.q === 'string' ? value.q : fallback.q,
	types: Array.isArray(value?.types) ? value.types : fallback.types,
	saved: Array.isArray(value?.saved) ? value.saved : fallback.saved,
	scope: {
		...EMPTY_STRUCTURE_SEARCH_SESSION.scope,
		...fallback.scope,
		...value?.scope,
		state: normalizeSearchState(
			value?.scope?.state ?? fallback.scope.state,
		),
	},
})

export default (state = initialState, action: Actions): State => {
	switch (action.type) {
		case UPDATE_SETTINGS: {
			return {
				...state,
				...action.payload,
				structureSearch: normalizeStructureSearch(
					action.payload.structureSearch,
					state.structureSearch,
				),
				userInterface: {
					...state.userInterface,
					...action.payload.userInterface,
					scriptEditor: {
						...state.userInterface.scriptEditor,
						...action.payload.userInterface?.scriptEditor,
					},
				},
			}
		}

		case UPDATE_STRUCTURE_SEARCH: {
			return {
				...state,
				structureSearch: normalizeStructureSearch(
					{ ...state.structureSearch, ...action.payload },
					state.structureSearch,
				),
			}
		}

		default: {
			return state
		}
	}
}
